"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _infoMessage = require("@/api/infoMessage");
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _validate = require("@/utils/validate");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'addSystemInfo',
  data: function data() {
    return {
      listLoading: false,
      formValidate: {
        name: '',
        sort: "1",
        status: 1,
        is_top: 0,
        start_time: "",
        end_time: ""
      }
    };
  },
  components: {
    Tinymce: _index.default
  },
  computed: {
    rules: function rules() {
      return {
        name: [{
          required: true,
          message: this.$t('qsrggmc'),
          trigger: 'blur'
        }],
        start_time: [{
          required: true,
          message: this.$t('qxz'),
          trigger: 'change'
        }],
        end_time: [{
          required: true,
          message: this.$t('qxz'),
          trigger: 'change'
        }]
      };
    }
  },
  mounted: function mounted() {
    this.getEditData();
  },
  methods: {
    getEditData: function getEditData() {
      var isCreate = sessionStorage.getItem('isCreate');
      if (isCreate == 1) {
        this.formValidate = {};
        this.formValidate = JSON.parse(sessionStorage.getItem('editDate'));
      } else {
        this.formValidate = {
          name: '',
          sort: "1",
          status: 1,
          is_top: 0,
          start_time: "",
          end_time: ""
        };
      }
    },
    submitForm: (0, _validate.Debounce)(function () {
      var _this = this;
      this.$refs.user.validate(function (valid) {
        if (valid) {
          _this.listLoading = true;
          var data = _objectSpread({}, _this.formValidate);
          var isCreate = sessionStorage.getItem('isCreate');
          (0, _infoMessage.saveSystemNotice)(data).then(function (res) {
            _this.$message.success(isCreate == 1 ? _this.$t('xgcg') : _this.$t('xzcg'));
            _this.listLoading = false;
            _this.$store.dispatch('tagsView/delView', _this.$route);
            _this.$router.back();
          }).finally(function () {
            _this.listLoading = false;
          });
        } else {
          return false;
        }
      });
    })
  }
};
exports.default = _default;